import { ObservableFromFetch } from "../ObservableFromFetch"
import GlobalParameterData from "./Model/GlobalParameterData"

export function GetGlobalParameter(parameterTitle: string) {
    const requestBody: string = new URLSearchParams({
      parameterTitle: parameterTitle.toString()
    }).toString()
  
    return ObservableFromFetch<GlobalParameterData>("FFOrderGlobalParameters/GetGlobalParameters?" + requestBody)

}

export function GlobalParameterUpdate(data: GlobalParameterData) {
  const requestBody = JSON.stringify({

    ParameterID: data.ParameterID ? data.ParameterID : undefined,
    ParameterTitle: data.ParameterTitle,
    ParameterDescription: data.ParameterDescription,
    ParameterType: data.ParameterType,
    ParameterValue: data.ParameterValue,
    CreatedBy: '',
    ModifiedBy: ''
  })

  return ObservableFromFetch<string>("FFOrderGlobalParameters/SetGlobalParameters", requestBody)
}
